import React from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { ROLE_TYPES } from './RoleTag.constants';
import { tagStyles } from './RoleTag.styles';

const RoleTag = ({ roleType, children, dataTruncated = false }) => (
  <Typography data-truncated={dataTruncated} sx={tagStyles(roleType)} variant="regular14">
    {children}
  </Typography>
);

RoleTag.propTypes = {
  roleType: PropTypes.oneOf(Object.values(ROLE_TYPES)).isRequired,
  children: PropTypes.node.isRequired,
  dataTruncated: PropTypes.bool,
};

export default RoleTag;
